import { Icon, Spinner } from '@paysera/ui';
import { useTranslation } from 'react-i18next';
import HeaderMobile from './HeaderMobile';
import { InvestmentItem } from './InvestmentItem';
import PaginationMobile from './PaginationMobile';
const InvestorTableMobile = ({ data, config, pagination, onPageChange, onDetailsClick, onFilterChange, filters, isFetching = false, showCreditScore, showInvestmentStatus, }) => {
    const { t } = useTranslation();
    return (<div className="relative">
            <div className="flex flex-col gap-4">
                <HeaderMobile onFilterChange={onFilterChange} filters={filters} showCreditScore={showCreditScore} showInvestmentStatus={showInvestmentStatus}/>
                {data.map((item) => (<InvestmentItem key={item.id} rows={config.getMobileRows(item, t)} actions={<button className="flex row body-s text-neutral-secondary-initial gap-x-1" type="button" onClick={() => onDetailsClick(item.id)}>
                                <Icon name="info_filled" className="text-neutral-secondary-initial"/>
                                {t('financing.active_loan.details')}
                            </button>}/>))}
                <PaginationMobile pagination={pagination} totalPages={pagination.pageCount} onPageChange={onPageChange}/>
            </div>
            {isFetching && (<div className="absolute inset-0 bg-white/60 z-10 flex items-center justify-center">
                    <Spinner className="w-8 h-8"/>
                </div>)}
        </div>);
};
export default InvestorTableMobile;
